import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const PendingBankStdLoans = () => {
    const [bankStdLoan, setbankStdLoan] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchbankStdLoan();
    }, []);

    const fetchbankStdLoan = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/bankStdLoan/pending');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setbankStdLoan(data);
        } catch (error) {
            console.error('Error fetching Student Loans:', error);
        }
    };

    const handleDelete = async (bankStdLoanId) => { 
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this student loan?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/bankStdLoan/delete/${bankStdLoanId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setbankStdLoan(bankStdLoan.filter(bankStdLoan => bankStdLoan.id !== bankStdLoanId));
                        Swal.fire({
                            title: "Deleted!",
                            text: "The student loan has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete Student Loan');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the student loan.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting Student Loan:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the student loan.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handleApprove = async (bankStdLoanId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to approve this student loan?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, approve it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/bankStdLoan/approve/${bankStdLoanId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setbankStdLoan(bankStdLoan.filter(bankStdLoan => bankStdLoan.id !== bankStdLoanId));
                        Swal.fire({
                            title: "Approved!",
                            text: "The student loan has been approved.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to approve Student Loan');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to approve the student loan.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error approving Student Loan:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to approve the student loan.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter bank student loans based on search term
    const filteredBankStdLoans = bankStdLoan.filter(loan =>
        (loan.loanName && loan.loanName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.bankName && loan.bankName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.loanDescription && loan.loanDescription.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.bankPhone && loan.bankPhone.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.bankEmail && loan.bankEmail.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (
        <div>
            <AdminDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>PENDING BANK STUDENT LOANS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>
                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                                <tr>
                                    <th>Bank Name</th>
                                    <th>Student Loan Name </th>
                                    {/* <th>University Name</th> */}
                                    <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>Location</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredBankStdLoans.map((bankStdLoan) => (
                                    <tr key={bankStdLoan.id}>
                                        <td>{bankStdLoan.bankName}</td>
                                        <td>{bankStdLoan.stdLoanName}</td>
                                        {/* <td>{bankStdLoan.university}</td> */}
                                        <td>{bankStdLoan.phone}</td>
                                        <td>{bankStdLoan.email}</td>
                                        <td>{bankStdLoan.location}</td>
                                        <td><a href={bankStdLoan.link} target="_blank" rel="noopener noreferrer" id='view-website'>Link</a></td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='app-details' onClick={() => handleApprove(bankStdLoan.id)}>APPROVE</a>
                                            <a href="#!" id='del-details' onClick={() => handleDelete(bankStdLoan.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PendingBankStdLoans;
